module.exports = __webpack_public_path__ + "static/media/v36.f65099ff.mp4";